<template>
  <div class="home">
    <video
      v-if="showVideo"
      ref="bgVideo"
      class="home-bg-video"
      :poster="poster"
      autoplay
      loop
      muted
      playsinline
      webkit-playsinline
      x5-playsinline
      preload="auto"
      aria-hidden="true"
      tabindex="-1"
      @error="showVideo = false"
    >
      <source
        :src="webm"
        :type="webmType"
      >
      <source
        :src="mp4"
        type="video/mp4"
        @error="showVideo = false"
      >
    </video>
    <div class="home-inner">
      <h1 class="home-logo">
        搜狗视频
      </h1>
      <SearchBar />
    </div>
  </div>
</template>

<script>
import poster from '@asset/img/home/home_bg_poster.jpg';
import mp4 from '@asset/media/home/home_bg.mp4';
import webm from '@asset/media/home/home_bg.webm';

import { getSsrUigsParams } from '../common/js/util';
import SearchBar from './components/SearchBar';

export default {
  components: {
    SearchBar,
  },
  asyncData({ context, store, route }) {
    return store
      .dispatch('home/prefetchData', { context, route })
      .catch(err => console.log('[PREFETCH_HOME_ERROR]', err));
  },
  data() {
    return {
      webm,
      mp4,
      poster,
      webmType: 'video/webm; codecs="av01.0.08M.08"',
      showVideo: true,
    };
  },
  mounted() {
    const params = getSsrUigsParams();
    window.UIGS_PARA = params;
    this.$uigs.send(params);
    this.initBgVideo();
  },
  beforeDestroy() {
    document.removeEventListener('visibilitychange', this.updatePlayback);
  },
  methods: {
    initBgVideo() {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.showVideo = false;
        return;
      }
      document.addEventListener('visibilitychange', this.updatePlayback);
      this.updatePlayback();
    },
    updatePlayback() {
      const video = this.$refs.bgVideo;
      if (!video) return;
      if (document.hidden) {
        video.pause();
      } else {
        // 低电量模式等禁止自动播放时保留封面
        const p = video.play();
        if (p && p.catch) p.catch(() => {});
      }
    },
  },
};
</script>

<style lang="scss">
.home {
  position: relative;
  min-height: 100vh;
  background: #0b1220 url('~@asset/img/home/home_bg_poster.jpg') center center no-repeat;
  background-size: cover;

  html[data-theme='dark'] & {
    background-color: #0b1220;

    &:before {
      content: '';
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 1;
      background: rgba(0, 0, 0, 0.6);
      pointer-events: none;
    }
  }
}

.home-bg-video {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 0;
}

.home-inner {
  position: relative;
  z-index: 2;
  padding: 26vh 20px 0;
  box-sizing: border-box;
}

.home-logo {
  height: 33px;
  margin: 0 auto 24px;
  overflow: hidden;
  font-size: 0;
  background: url('~@asset/img/home/index_logo.png') center center no-repeat;
  background-size: contain;

  html[data-theme='dark'] & {
    opacity: 0.85;
  }
}
</style>
